import styled from 'styled-components'
import ReactApexChart from 'react-apexcharts'
import { useMedia } from 'react-use'
import "./styles.css"

const Wrapper = styled.div`
  width:100%;
  background:#0C0720;
  position:relative;
  top:-4px;
  & #chart svg path  {
    stroke: transparent;
  }
  & .apexcharts-canvas {
    width:100px;
    height:100px;
  }
`

const Inner = styled.div`
  max-width:1200px;
  width:90%;
  margin:0 auto;
  display:flex;
  justify-content:space-between;
  flex-wrap:wrap;
`
const Leftside = styled.div`
  display:block;
  width:50%;
  top:10vh;
  @media(max-width:912px){
    width:100%;
  }
`
const Rightside = styled.div`
  display:block;
  width:50%;
  @media(max-width:1144px){
    margin-top:72px;
    .apexcharts-canvas {
      margin-left: 0%;
    }
  }
  @media(max-width:600px){
    margin-top: 12vh;
    margin-left: 25vw;
    .apexcharts-canvas {
      margin-left: -80%;
    }
  }
  @media(max-width:280px){
    margin-left:42vw;
  }
  @media(max-width:414px){
    margin-left:30vw;
  }
  position:relative;
  & .apexcharts-canvas {
    width:500px;
  }
`
const Header = styled.span`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 72px;
  display: inherit;
  line-height: 70px;
  letter-spacing: -1px;
  text-transform: uppercase;
  color: #FF7070;
  margin-bottom:24px;
  max-width: 530px;
  @media(max-width:1144px){
    max-width: 100%;
  }
  @media(max-width:535px){
    font-size:40px;
    line-height:45px;
  }
  @media(max-width:360px){
    font-size:30px;
  }
`
const Text = styled.span`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 1px;
  color: #FCFCFC;
  margin-bottom:56px;
`
const Title = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #FCFCFC;
`
const Circle = styled.div < { color?: any } > `
  width:24px;
  height:24px;
  border-radius:100%;
  background:${({ color }) => color};
  margin-right:24px;
`
const TitleBar = styled.div`
  display:flex;
  margin-top:16px;
`
interface chartType {
  color: string,
  text: string,
  amount: number
}

const Chartinfos: chartType[] = [
  {
    color: "#E354FA",
    text: "Team Fund (Burn)",
    amount: 5000
  },
  {
    color: "#84FF70",
    text: "Initial Liquidity (Burn)",
    amount: 40000
  },
  {
    color: "#6C60F6",
    text: "RBT Reserve (Time-locked)",
    amount: 50000
  },
  {
    color: "#D6EE47",
    text: "Marketing Fund",
    amount: 5000
  }
]

const Features = () => {
  const isMobile = useMedia('(max-width:800px)')
  const series = [5, 40, 5, 50]
  const options = {
    labels: ["Team Fund (Burn)", "Initial Liquidity (Burn)", "Marketing Fund", "RBT Reserve (Time-locked)"],
    colors: ["#E354FA", "#84FF70", "#D6EE47", "#6C60F6"],
    dataLabels: {
      enabled: false
    },
    title: {
      text: 'Total Supply',
      align: 'center',
      floating: true,
      // offsetX: -10,
      offsetY: 200,
      style: {
        fontSize: '18px',
        fontFamily: 'Poppins',
        fontWeight: 300,
        color: '#FCFCFC',
      }
    },
    subtitle: {
      text: '100,000 RBT',
      align: 'center',
      floating: true,
      // offsetX: -5,
      offsetY: 220,
      style: {
        fontSize: '30px',
        fontFamily: 'Poppins',
        fontWeight: 700,
        color: '#FCFCFC',
      }
    },
    responsive: [
      {
        breakpoint: 900,
        options: {
          chart: {
            offsetX: -30,
            offsetY: -30,
            width: '550px',
            height: '550px',
          },
          title: {
            style: {
              fontSize: '20px'
            },
            offsetY: 180,
            offsetX: 16,
          },
          subtitle: {
            style: {
              fontSize: '28px'
            },
            offsetY: 240,
            offsetX: 15,
          },
          legend: {
            position: 'left'
          }
        }
      },
      {
        breakpoint: 600,
        options: {
          chart: {
            offsetX: 0,
            offsetY: -50,
            width: '350px',
            height: '350px',
          },
          title: {
            style: {
              fontSize: '18px'
            },
            offsetY: 130,
          },
          subtitle: {
            style: {
              fontSize: '20px'
            },
            offsetY: 150,
          },
          legend: {
            position: 'left'
          }
        }
      }
    ],
    tooltip: {
      enabled: true,
      shared: true,
      custom: function (options: any) {
        var data = options.w.globals.labels[options.seriesIndex]
        var item = Chartinfos.filter((ot: chartType) => ot.text === data)[0]
        var percent = item.amount / 1000
        var isBurned = data.includes("Burn")
        return '<div >' +
          '<div>' + percent + '%' + '</div>' +
          '<div>' + data.replace('(Burn)', '') + '</div>' +
          '<div>' + item.amount.toLocaleString() + ' RBT ' + (isBurned ? '(Burned)' : '') + '</div>' +
          '</div>';
      }
    },
    chart: {
      events: {
        markerClick: function (options: any) {
          var data = options.w.globals.labels[options.seriesIndex]
          var item = Chartinfos.filter((ot: chartType) => ot.text === data)[0]
          var percent = item.amount / 1000
          return '<div >' +
            '<div>' + percent * 10 + '%' + '</div>' +
            '<div>' + data + '</div>' +
            '<div>' + item.amount.toLocaleString() + ' RBT (Burned)</div>' +
            '</div>';
        }
      }
    },
    yaxis: {
      show: true,
      tooltip: {
        enabled: true,
      }
    },
    stroke: {
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '53$',
        }
      }
    }
  }

  return (
    <Wrapper id="Token Distribution">
      <Inner>
        <Leftside>
          <Header>DISTRIBUTION OF THE RBT TOKEN</Header><br />
          <div style={{ height: isMobile ? '0px' : '24px' }} />
          <Text> Here is overview of the token distribution</Text>
          {
            Chartinfos.map((info, index) => (
              <TitleBar key={index}>
                <Circle color={info.color} />
                <Title>{info.text}</Title>
              </TitleBar>
            ))
          }
        </Leftside>
        <Rightside>
          <div id='chart'>
            <ReactApexChart type='donut' options={options as any} series={series} height={'450px'} />
          </div>
        </Rightside>
      </Inner>
    </Wrapper>
  )
}

export default Features